export default "__VITE_ASSET__uS_9R_j0__"